module.exports = __webpack_public_path__ + "static/media/rísí.bc5fab2f.svg";